export default __webpack_public_path__ + "static/media/encoding.fc6f44e3.svg";